const SOCIAL_NETWORK_LABELS = {
    facebook: "Facebook",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    other: "Red social",
};

const KNOWN_NETWORKS = ["facebook", "instagram", "linkedin"];

/**
 * Pick a social network key from a URL for icon rendering.
 * Falls back to "other" when no known network is present.
 */
export function getSocialNetworkKey(url = "") {
    const normalized = String(url).toLowerCase();
    return KNOWN_NETWORKS.find((key) => normalized.includes(key)) || "other";
}

export function getSocialNetworkAriaLabel(url = "") {
    return SOCIAL_NETWORK_LABELS[getSocialNetworkKey(url)];
}

export function ensureAbsoluteUrl(url = "") {
    return url.startsWith("http") ? url : `https://${url}`;
}

export function shouldExpandProducerDescription(description) {
    return Array.isArray(description) && description.length > 3;
}
